import React from "react";

function TitleBanner({
  title,
  subtitle,
  style,
  children,
  titleStyle,
  subtitleStyle,
  bordered = true,
}) {
  return (
    <div
      className={"ahp-title-bar"}
      style={{ ...style, border: bordered ? "1px solid grey" : "none" }}
    >
      <div>
        <div className="ahp-title-bar title" style={titleStyle}>
          {title}
        </div>
        <div className="ahp-title-bar subtitle" style={subtitleStyle}>
          {subtitle}
        </div>
      </div>
      {children}
    </div>
  );
}

export default TitleBanner;
